import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import createCsvEnrichmentTrackingService from "app/pages/sales-intelligence/services/tracking/enrichment/csv/factory";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import type { CustomAttributes } from "app/services/track/track";

const createEnrichmentTrackingService = (track: TrackFn) => {
    return {
        csv: createCsvEnrichmentTrackingService(track),

        trackStartCrmEnrichmentAction: (integrationName: Integration, customEvent?: CustomAttributes) => {
            track("Enrichment", "click", `get started/${integrationName} enrichment`, customEvent);
        },

        trackEnrichmentAction: (eventName: string, customEvent?: CustomAttributes) => {
            track("Enrichment", "click", eventName, customEvent);
        },
    };
};

export default createEnrichmentTrackingService;
